// extracted by mini-css-extract-plugin
export default {"root":"MobileAppBanner_root__ClOqD","icon":"MobileAppBanner_icon__koYBJ","title":"MobileAppBanner_title__eL6ya"};